<template>
  <div class="pages-bg">
    <div class="pages" ref="pages">
      <span class="page-items" v-if="canRun" @click="run(); $forceUpdate();">runCode()</span>
      <span class="page-items" v-if="canRun" @click="canRun = !canRun;  $forceUpdate();">Execution Enabled</span>
      <span class="page-items" style="color: hotpink;" v-if="!canRun" @click="canRun = !canRun; $forceUpdate();">Execution Disabled</span>
      <router-link class="page-items" to="/">Home</router-link>
      <span class="page-items" @click="addPage()">(add)</span>
      <span class="page-items" :class="{ 'item-selected': currentPageIndex === index }" v-for="(page, index) in pages" @click="selectPage(index)">({{ index + 1 }}: {{ getFirstLine(page) }})</span>
      <span class="page-del" v-if="pages.length > 0" @click="removeThisPage()">remove</span>
    </div>
    <iframe ref="iframe" style="display: none;" />
    <div ref="firepadDiv" class="firepad-div" :style="{ height: coderHeight }"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import brace from 'brace'
// import 'brace/mode/svg'
// import 'brace/mode/scss'
// import 'brace/mode/html'
import 'brace/mode/javascript'
// import 'brace/mode/jsx'
// import 'brace/mode/css'
import 'brace/theme/monokai'
// import 'brace/ext/searchbox'

import { db } from '@/firebase'

var dbPages = db.ref('codebase/pages')

export default {
  name: 'hello',
  firebase: {
    pages: {
      source: dbPages,
      readyCallback () {
        this.autoResize()
        this.ready = true
      }
    }
  },
  data () {
    let canRun = JSON.parse(window.localStorage.getItem('canRun-fire-pad'))
    if (canRun === null) {
      window.localStorage.setItem('canRun-fire-pad', false)
    }
    console.log('read', canRun)
    return {
      canRun,
      coderHeight: 'calc(100vh - 90px)',
      stop: false,
      editor: null,
      ready: false,
      currentPageIndex: 0,
      timer: 0,
      runTimer: 0,
      pages: []
    }
  },
  methods: {
    autoResize () {
      if (this.$refs['pages']) {
        let val = 'calc( 100vh - ' + (this.$refs['pages']).getBoundingClientRect().height + 'px)'
        this.coderHeight = val
      }
    },
    addPage () {
      dbPages.push({
        code: `//Welcome`
      })

      this.currentPageIndex = this.pages.length - 1

      Vue.nextTick(() => {
        this.autoResize()
      }, this)
    },
    removeThisPage () {
      if (this.currentPage && window.confirm('Remove this page?\n' + this.getFirstLine(this.currentPage))) {
        dbPages.child(this.currentPage['.key']).remove()
        var lastIndex = this.currentPageIndex - 1
        this.currentPageIndex = lastIndex >= 0 ? lastIndex : 0
      }

      Vue.nextTick(() => {
        this.autoResize()
      }, this)
    },
    selectPage (index) {
      this.currentPageIndex = index
    },
    saveCurrentCode () {
      if (this.currentPage && this.currentPage['.key']) {
        dbPages.child(this.currentPage['.key']).child('code').set(this.currentPage.code)
      }
    },
    shouldSave () {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.saveCurrentCode()
      }, 150)
    },
    sendCodeToEditor () {
      this.stop = true
      if (this.currentCode !== this.editor.getValue()) {
        var pos = this.editor.session.selection.toJSON()
        this.editor.setValue(this.currentCode)
        this.editor.session.selection.fromJSON(pos)
        this.run()
      }
      this.stop = false
    },
    getFirstLine (page) {
      var output = (page.code.split('\n') || [''])[0]
      return (output === '' ? 'new file' : output.replace('//', ''))
    },
    run () {
      var output = this.currentCode

      // let lines = output.split('\n')
      // output = lines.map((output) => {
      //   let rand = Math.floor(Math.random() * 100000000) + '_' + Math.floor(Math.random() * 100000000)

      //   let hasForLoop = output.indexOf('for') !== -1

      //   if (hasForLoop) {
      //     if (output.indexOf('{') !== -1) {
      //       output = `var Loop_Protector_${rand} = 0; ${output}`
      //       output = output.replace('{', `{
      //           if (Loop_Protector_${rand} > 1000) { break; } else { Loop_Protector_${rand}++; }
      //       `)
      //     } else {
      //       if (output.indexOf('//') !== -1) {

      //       } else if (output.indexOf('\'') !== -1) {

      //       } else {
      //         output = `throw new Error('wrong for loop');`
      //       }
      //     }
      //   }

      //   return output
      // }).join('\n')

      // console.clear()

      // console.clear();
      // var self = this
      // console.table([
      //   {
      //     code: self.currentCode
      //   },
      //   {
      //     code: output
      //   }
      // ])

      // function utoa (str) {
      //   return window.btoa(unescape(encodeURIComponent(str)))
      // }

      clearTimeout(this.runTimer)
      this.runTimer = setTimeout(() => {
        let code = '<script>console = window.top.console; ' + output + '</' + 'script>'

        let blob = new Blob([code], { type: 'text/html' })
        let url = URL.createObjectURL(blob)

        if (this.$refs['iframe'] && this.canRun) {
          this.$refs['iframe'].src = url
        }
      }, 300)

      /* eslint-disable no-new-func */
//       try {
//         let run = new Function(`
//           try {
// ${output}
//           } catch (err) {
//             console.trace()
//             console.error(err)
//           }
//         `)
//         run()
//       } catch (err) {
//         console.error(err)
//       }
    }
  },
  computed: {
    currentPage () {
      if (this.pages) {
        return this.pages[this.currentPageIndex]
      } else {
        return false
      }
    },
    currentCode () {
      return this.currentPage ? this.currentPage.code : ''
    }
  },
  watch: {
    canRun () {
      window.localStorage.setItem('canRun-fire-pad', this.canRun)
      console.log('save', this.canRun)
    },
    coderHeight () {
      Vue.nextTick(() => {
        this.editor.resize()
      }, this)
    },
    pages () {
      if (this.pages.length === 0) {
        this.editor.setValue(`//Welcome to Lok Lok Academy\n//click add to create code`)
        this.editor.setOption('readOnly', true)
      } else {
        this.editor.setOption('readOnly', false)
      }
    },
    currentPageIndex () {
      if (this.currentPage) {
        this.sendCodeToEditor()
      }
    }
  },
  mounted () {
    var editor = this.editor = brace.edit(this.$refs.firepadDiv)

    window.addEventListener('resize', () => {
      this.autoResize()
    }, false)
    this.autoResize()

    // setInterval(() => {
    //   this.sendCodeToEditor()
    // }, 500)

    dbPages.on('value', () => {
      this.sendCodeToEditor()
    })

    editor.setTheme('ace/theme/monokai')
    editor.setFontSize(20)
    this.editor.$blockScrolling = Infinity

    this.editor.on('change', () => {
      if (this.currentPage && !this.stop) {
        this.currentPage.code = this.editor.getValue()
        this.shouldSave()
        this.run()
      }
    })

    var session = editor.getSession()
    session.setUseWrapMode(true)
    session.setUseWorker(false)
    session.setMode('ace/mode/javascript')

    var commands = [
      {
        name: 'save',
        bindKey: { win: 'Ctrl-S', mac: 'Command-S' },
        exec: function (editor) {
          var val = editor.getValue()
          if (this.save) {
            this.save(val)
          }
          console.log('Code:\n', val)
        }.bind(this),
        readOnly: true // false if this command should not apply in readOnly mode
      },
      {
        name: 'multicursor',
        bindKey: { win: 'Ctrl-D', mac: 'Command-D' },
        exec: function (editor) {
          editor.selectMore(1)
        },
        // multiSelectAction: 'forEach',
        scrollIntoView: 'cursor',
        readOnly: true // false if this command should not apply in readOnly mode
      }
    ]

    commands.forEach((command) => {
      this.editor.commands.addCommand(command)
    })

    // var firepadRef = this.firepadRef = db.ref('/firepad')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
.pages{
  background-color: #2F3129;
  width: 100vw;
  color: #8F908A;
  font-size: 18px;
  line-height: 30px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;
}
.pages-bg{
  width: 100%;
  height: 100%;
  background-color: #2F3129;
}
.page-items {
  display: inline-block;
  color: lime;
  padding: 0 10px;
}

.page-items.item-selected{
  color: cyan;
}

.page-del {
  float: right;
  color: red;
  padding: 0 10px;
}

.firepad-div{
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// Firepad.vue?0dce32a6